<script setup>
import { computed, defineEmits, defineProps } from 'vue';

const props = defineProps({ visible: Boolean, value: String, accounts: Array });
const emit = defineEmits(['update:visible', 'input', 'confirm']);

const visible = computed({
  get() {
    return props.visible;
  },
  set(val) {
    emit('update:visible', val);
  },
});

const select = computed({
  get() {
    return props.value;
  },
  set(val) {
    emit('input', val);
  },
});
</script>

<template>
  <van-dialog
    v-model="visible"
    :title="$t('dialog.multiAccounts')"
    show-cancel-button
    :confirm-button-text="$t('dialog.confirmButton')"
    :cancel-button-text="$t('dialog.cancelButton')"
    @confirm="emit('confirm')"
  >
    <div class="max-h-36 overflow-auto px-6 pb-4 mt-4">
      <div
        v-for="item in accounts"
        :key="item.uid"
        class="flex justify-between cursor-pointer h-10 py-2 mb-2"
        @click="select = item.uid"
      >
        <div class="flex">
          <img src="../asset/img/user.svg" alt="" class="w-6 mr-2" />
          <div class="text-base">{{ item.maskUid }}</div>
        </div>
        <el-radio v-model="select" :label="item.uid"></el-radio>
      </div>
    </div>
  </van-dialog>
</template>

<style scoped lang="less">
:deep(.el-radio__label) {
  display: none;
}

:deep(.el-radio__input) {
  margin-top: 5px;

  &.is-checked .el-radio__inner {
    border-color: #0067d1;
    background-color: #0067d1;
  }
}

:deep(.van-dialog__content) {
  padding: 0;
}
</style>
